import React from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import "./style.scss";
import { PACKAGING } from './packagingJson';
import { Link } from "react-router-dom";
import { toRoute } from "../../../i18n";
import { Media, MediaContextProvider } from "../../../media";
import WhyLussopackMoreInfo from "../../../components/whyLussopack/whyLussoPackMoreInfo";


function Cosmetics(props) {
  const contentDescription = (
    <div className="descriptionConatainer mb-5">        
      <h2 className="mb-4">Luxury Packaging and Displays for All Industries</h2>
      <p>Lussopack offers wholesale packaging and display solutions designed to meet the needs of various industries. From luxury gift boxes to jewelry and watch displays, our products combine functionality and style to create a lasting impression.</p>
      <h2 className="mb-4 mt-5">Tailored Packaging for Specific Products</h2>
      <p>Our tailored solutions ensure that each product is packaged to reflect its value and purpose.</p>
      <h3>Watch Packaging and Displays</h3>
      <p>We provide <a href='https://lussopack.com/packaging/watch-packaging' target="_blanl">sturdy watch boxes</a> and <a href="https://lussopack.com/packaging/watch-displays" target="_blank">elegant watch displays</a> that protect and showcase timepieces with precision and sophistication.</p>
      <h3>Jewelry Packaging and Displays</h3>
      <p>Our range of jewelry packaging includes <a href='https://lussopack.com/packaging/jewelry-cases'>premium jewelry cases</a>, <a href='https://lussopack.com/packaging/jewelry-pouches' target="_blank">jewelry ouches</a>, and <a href='https://lussopack.com/packaging/jewelry-displays' target="_blank">display stands</a>, all designed to highlight necklaces, rings, earrings, and other fine pieces.</p>
      <h3>Luxury Gift Boxes</h3>
      <p>Crafted from high-quality materials, our luxury gift boxes offer a stunning presentation for high-value items, making them ideal for retail and gifting purposes.</p>
      <h2 className="mb-4 mt-5">Sustainable and Durable Materials</h2>
      <p>Sustainability and quality are at the core of our packaging solutions.</p>
      <h3>Eco-Friendly Packaging</h3>
      <p>We offer environmentally conscious options made with sustainable materials that reduce environmental impact without compromising on practicality or aesthetics.</p>
      <h3>Quality That Endures</h3>
      <p>Our packaging is crafted from durable materials to ensure long-lasting protection and an elegant finish for all products.</p>
      <h2 className="mb-4 mt-5">Comprehensive Product Range and Customization</h2>
      <p>Our extensive catalog and customizable options make Lussopack a versatile partner for packaging needs.</p>
      <h3>Diverse Packaging Solutions</h3>
      <p>We provide a variety of options, including jewelry displays, watch boxes, pouches, and custom gift boxes, catering to retail and luxury markets.</p>
      <h3>Customizable Designs</h3>
      <p>Each packaging solution can be tailored to align with specific branding and product requirements, offering businesses a unique and cohesive look.</p>
    </div>
  )

  const summaryDescription = (
    <div className='summaryDescription'>
      <h2 className='mb-3 mt-5'>Lussopack: Your Custom Luxury Wholesale Packaging Partner</h2>
      <p>Based in Bangkok, Thailand, Lussopack is a leading luxury packaging manufacturer with over 30 years of expertise, delivering exceptional quality and personalized service.</p>
      <h3 className="mb-2">More Than Luxury Packaging Manufacturing</h3>
      <p>We work with clients to craft luxury packaging that fosters emotional connections, builds brand loyalty, and inspires advocacy.</p>
      <h3 className="mb-2">Broad Specialization in Wholesale Luxury Gift Packaging</h3>
      <p>From jewelry packaging, and jewelry display to custom designs for high-end brands like perfume, rigid, and gift boxes, we ensure superior craftsmanship in every product.</p>

      <h3 className="mb-2">Tailor-Made Solutions for Your Brand</h3>
      <p>Choose from an extensive range of premium materials and finishes, or work with our experts to develop bespoke packaging that embodies your brand's essence.</p>
      <h3 className="mb-2">Efficient Logistics Services</h3>
      <p>Take advantage of our warehousing, distribution, and direct packaging solutions to streamline operations, cut costs, and manage your supply chain with ease.</p>
      <h3 className="mb-2">Client-Focused Commitment</h3>
      <p>At Lussopack, we are passionate about delivering flawless luxury packaging solutions that align with your brand’s vision and exceed your expectations.</p>
      <h3 className="mb-2">Contact Us Today</h3>
      <p>Let us help bring your luxury gift box vision to life. Reach out to our team and discover how we can create the perfect solution for your brand.</p>
  </div>
  )


  return (
    <>
      <Helmet>
        <title>Wholesale Luxury Packaging & Gift Boxes Supplier | Lussopack</title>
        <meta name="description" content="Explore Lussopack's luxury packaging solutions, offering a wide range of materials and custom options for jewelry boxes, pouches, displays, cases, and more." />
        <meta name="keywords" content="Tailored Luxury Packaging" />
        <link rel="canonical" href="https://lussopack.com/packaging/" />        
      </Helmet>

      {/* <ScrollToTopOnMount /> */}
      <HeaderTitle
        {...props}
        textHeader={"Wholesale Tailored Packaging Solutions"}
        textSubHeader={"We are confident that our tailored packaging will be the perfect fit for our customers’ valuable business. "}
        isShowOurReference={true}
      />

      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="packaging">
              <h2 className="text-center">Luxury Packaging and Gift Boxes for Every Need</h2>
              <div className="packagingList">
                {
                  PACKAGING.map((packaging, index)=>(
                        <Link key={index} className={`packagingItem`} to={toRoute(`${packaging.path}`)}>
                          <Image
                            src={asset(`${packaging.itemImageDesktop}`)}
                            alt={`${packaging.item}`}
                            className="img-fluid"
                            width="345"
                            height="345"
                          />
                          <p className="text-center mt-2">{packaging.item}</p>
                          <span>{packaging.itemDescription}</span>
                        </Link>
                  ))
                }
              </div>
              {contentDescription}
              <WhyLussopackMoreInfo />
              {summaryDescription}
          </div>
       </Media>

       <Media lessThan="md">
        <div id="packagingMobile">
            <h2>Luxury Packaging and Gift Boxes for Every Need</h2>
            <div className="packagingList">
              {
                PACKAGING.map((packaging, index)=>(
                      <Link key={index} className={`packagingItem`} to={toRoute(`${packaging.path}`)}>
                        <Image
                          src={asset(`${packaging.itemImageDesktop}`)}
                          alt={`${packaging.item}`}
                          className="img-fluid"
                          width="345"
                          height="345"
                        />
                        <p>{packaging.item}</p>
                        <span>{packaging.itemDescription}</span>
                      </Link>
                ))
              }
            </div>           
              {contentDescription}
              <WhyLussopackMoreInfo />
              {summaryDescription}
         </div>
       </Media>
       </MediaContextProvider>
    </>
  );
}

export default Cosmetics;
